module.exports = __webpack_public_path__ + "static/doctorMobile-7630e8c781d1dcaec80701484804ded6.png";